var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from 'react';
import { AntdForm, DrawerComponent, DrawerFooter, TextComponent } from 'renderer/components';
import notification from 'antd/lib/notification';
import { CustomerQuery } from 'renderer/queries';
var fields = [
    {
        element: (React.createElement(TextComponent, { type: "headline3", marginTop: 24, marginBottom: 30 }, "\uD0DC\uADF8 \uB4F1\uB85D")),
    },
    {
        type: 'text',
        itemProps: {
            name: 'name',
            label: '태그명',
            rules: [{ type: 'string', required: true, min: 1, max: 10 }],
        },
        inputProps: { placeholder: '태그명', autoFocus: true },
    },
    {
        type: 'color',
        itemProps: {
            name: 'color',
            label: '대표색상',
            rules: [{ required: true }],
        },
        inputProps: { placeholder: '색상 선택' },
    },
];
export var CustomerTagDrawer = function (_a) {
    var drawer = _a.drawer, storeId = _a.storeId, form = _a.form, onClose = _a.onClose;
    var create = CustomerQuery.useCreateCustomerTagMutation();
    var update = CustomerQuery.useUpdateCustomerTagMutation();
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var createTag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(drawer === null || drawer === void 0 ? void 0 : drawer.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, update.mutateAsync(__assign(__assign({}, values), { storeId: storeId, id: drawer.id }))];
                case 1:
                    _a.sent();
                    notification.success({ message: '태그가 수정되었습니다.' });
                    onClose();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, create.mutateAsync(__assign(__assign({}, values), { storeId: storeId }))];
                case 3:
                    createTag = _a.sent();
                    notification.success({ message: '태그가 생성되었습니다.' });
                    onClose(createTag);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (drawer) {
            form.setFieldsValue(drawer);
        }
    }, [drawer]);
    return (React.createElement(DrawerComponent, { title: "\uD0DC\uADF8 ".concat((drawer === null || drawer === void 0 ? void 0 : drawer.id) ? '수정' : '생성'), open: !!drawer, onClose: function () { return onClose(); }, footer: React.createElement(DrawerFooter, { onCancel: onClose, onConfirm: form.submit, confirmText: (drawer === null || drawer === void 0 ? void 0 : drawer.id) ? '수정' : '생성' }) },
        React.createElement(AntdForm, { formProps: {
                form: form,
                initialValues: { storeId: storeId },
                onFinish: handleSubmit,
            }, onSubmit: handleSubmit, fields: fields })));
};
